// src/hooks/useSplashWarmup.js
// The native splash stays up (launchAutoHide:false) with a spinner while we
// wake the backend (a cold Render dyno can take a few seconds). We hide the
// splash as soon as the health check returns — or after a hard cap so it can
// never hang. No-op on the web.
import { useEffect } from 'react';
import { isNativeApp } from '../utils/platform';

export function useSplashWarmup() {
  useEffect(() => {
    if (!isNativeApp()) return;
    let hidden = false;
    const hide = async () => {
      if (hidden) return;
      hidden = true;
      try {
        const { SplashScreen } = await import('@capacitor/splash-screen');
        await SplashScreen.hide();
      } catch { /* plugin absent — ignore */ }
    };

    const base = (process.env.REACT_APP_API_URL || '').replace(/\/api\/?$/, '');
    const warm = base
      ? fetch(base + '/health', { cache: 'no-store' }).catch(() => {})
      : Promise.resolve();

    // Hide when the backend answers, but never wait longer than 6s.
    Promise.race([warm, new Promise(r => setTimeout(r, 6000))]).finally(hide);
    const cap = setTimeout(hide, 8000); // absolute safety net
    return () => clearTimeout(cap);
  }, []);
}
